import clsx from 'clsx'

import styles from './NavBar.module.scss'

interface NavbarItem {
  key: string
  title: string
  ref?: React.RefObject<HTMLDivElement>
}

interface Props {
  items?: NavbarItem[]
}

const NavBar = ({ items }: Props) => {
  const handleScroll = (ref?: React.RefObject<HTMLDivElement>) => {
    if (ref?.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <div className={clsx(styles.NavBar)}>
      {!!items?.length &&
        items.map(({ key, title, ref }) => (
          <div className={styles.item} key={key} onClick={() => handleScroll(ref)}>
            {title}
          </div>
        ))}
    </div>
  )
}

export default NavBar
